import styled from 'styled-components';
import SummaryItem from './SummaryItem';
import IcDollar from '../../../../../components/Icon/icons/IcDollar';
import Sms from '../../../../../components/Icon/icons/IcSMS';
import IcFee from '../../../../../components/Icon/icons/IcFee';
import IcCall from '../../../../../components/Icon/icons/IcCall';
import IcMoney from '../../../../../components/Icon/icons/IcMoney';
import { formatCurrency } from '../../../../../utils/formatCurrency';
import { IGetPackageSmsDashboardResponse } from '../../services/types';

interface IBillingSummaryCardsProps {
  data?: IGetPackageSmsDashboardResponse | null;
}

const BillingSummaryCards = ({ data }: IBillingSummaryCardsProps) => {
  return (
    <Container>
      <SummaryItem label='Total Top Up' value={formatCurrency(data?.summary?.totalAmount || 0)} icon={<IcDollar fill='#D2464F' />} />
      <SummaryItem label='Text Message' value={data?.summary?.totalSms ?? 0} icon={<Sms fill='#008BFF' width={32} height={32} />} />
      <SummaryItem label='Text Cost' value={formatCurrency(data?.summary?.costSms || 0)} icon={<IcFee fill='#9747FF' />} />
      <SummaryItem label='Voice Calls' value={data?.summary?.totalVoice || 0} icon={<IcCall fill='#0DA472' />} />
      <SummaryItem label='Voice Cost' value={formatCurrency(data?.summary?.costVoice || 0)} icon={<IcFee fill='#2D6772' />} />
      <SummaryItem label='Balance' value={formatCurrency(data?.summary?.balance || 0)} icon={<IcMoney fill='#EBA33B' />} />
    </Container>
  );
};

export default BillingSummaryCards;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;
